import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';

import FormTextArea from '../Form/FormTextArea';
import Confirm from '../Confirm';
import MyModal from '../Modal';
import { Loading } from '../Loading';

import moment from 'moment';

import { useCalificacionHabilitacion } from '../../hooks/useCalificacionHabilitacion';
import { HAB_OBSERVADA_STATUS_ID } from '../../constants/constants';
import { TransicionEstado } from '../../types/TransicionEstado';
import { ObservacionHabilitacion } from '../../types/ObservacionHabilitacion';

type CalificarHabilitacionProps = {
  isOpen: boolean;
  toggle: () => void;
  habilitacionId: number;
  idEstadoTemporalActual?: number;
  onSaved?: () => void;
};

const CalificarHabilitacion: React.FC<CalificarHabilitacionProps> = ({
  isOpen,
  toggle,
  habilitacionId,
  idEstadoTemporalActual,
  onSaved,
}) => {
  const {
    getEstadosSiguientes,
    saveObservacionHabilitacion,
    getObservacionActual,
    enviarHabilitacion,
  } = useCalificacionHabilitacion();

  const [opciones, setOpciones] = useState<TransicionEstado[]>([]);
  const [idEstadoSeleccionado, setIdEstadoSeleccionado] = useState<string>(
    idEstadoTemporalActual ? '' + idEstadoTemporalActual : '',
  );
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    setIdEstadoSeleccionado(
      idEstadoTemporalActual ? '' + idEstadoTemporalActual : '',
    );
  }, [idEstadoTemporalActual]);

  useEffect(() => {
    if (isOpen && habilitacionId) {
      getEstadosSiguientes(habilitacionId).then(setOpciones);
      getObservacionActual(habilitacionId).then((obs) => {
        if (obs && obs.observacion) setMotivo(obs.observacion);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, habilitacionId]);

  const validar = (): boolean => {
    if (idEstadoSeleccionado === '') {
      toast.error('Por favor, seleccionar un estado para la Habilitación.');
      return false;
    }
    if (
      parseInt(idEstadoSeleccionado, 10) === HAB_OBSERVADA_STATUS_ID &&
      motivo.trim() === ''
    ) {
      toast.error('El campo motivo no puede estar vacío');
      return false;
    }
    return true;
  };

  const onClickGuardar = () => {
    if (!validar()) return;
    setShowConfirm(true);
  };

  const guardarObservacion = async (enviar: boolean) => {
    setShowConfirm(false);
    setLoading(true);
    try {
      const observacion: ObservacionHabilitacion = {
        id: null,
        idHabilitacionContratista: habilitacionId,
        observacion: motivo,
        idTipoEstadoTemporal: parseInt(idEstadoSeleccionado, 10),
        fechaObservacion: moment().format('YYYY-MM-DD'),
        usuario: '',
      };
      await saveObservacionHabilitacion(observacion);
      if (enviar) {
        await enviarHabilitacion(habilitacionId);
        toast.success('Habilitación enviada al siguiente estado.');
      } else {
        toast.success('Habilitación calificada correctamente.');
      }
      onSaved?.();
      toggle();
    } catch {
      /* el hook ya notifica el error */
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loading />}
      <Confirm
        isOpen={showConfirm}
        toggle={() => guardarObservacion(false)}
        title="Enviar Habilitación"
        yesFn={() => guardarObservacion(true)}
      >
        <div className="form-horizontal">
          <div className="row">
            <p>¿Desea enviar la habilitación al siguiente estado?</p>
          </div>
        </div>
      </Confirm>

      <MyModal
        isOpen={isOpen}
        toggle={toggle}
        title="Calificar Habilitación"
        cancelButton={false}
        secondButton={false}
      >
        <div>
          <div className="row">
            {opciones.map((opcion, index) => (
              <div
                key={opcion.idTipoEstadoSiguiente}
                className="col-md-12"
                style={{
                  marginLeft: '18px',
                  marginTop: index === 0 ? '2px' : '-12px',
                }}
              >
                <div className="form-check">
                  <input
                    type="radio"
                    name="idTipoEstadoTemporal"
                    value={opcion.idTipoEstadoSiguiente}
                    id={`hab-estado-${opcion.idTipoEstadoSiguiente}`}
                    className="form-check-input"
                    onChange={(e) => setIdEstadoSeleccionado(e.target.value)}
                    checked={
                      parseInt(idEstadoSeleccionado, 10) ===
                      opcion.idTipoEstadoSiguiente
                    }
                  />
                  <label
                    htmlFor={`hab-estado-${opcion.idTipoEstadoSiguiente}`}
                    className="form-check-label"
                    style={{ fontSize: '13px', fontWeight: '500' }}
                  >
                    {opcion.nombreTipoEstadoSiguiente}
                  </label>
                </div>
              </div>
            ))}
          </div>

          <div className="row mt-14 justify-content-center">
            <FormTextArea
              id={'motivo'}
              title={'Agregar Motivo'}
              name={'motivo'}
              value={motivo}
              onChange={(e: any) => setMotivo(e.target.value)}
              classDivTextArea={'col-14'}
              classLabel={'col-14'}
            />
          </div>
          <br />

          <div className="col-md-12 d-flex justify-content-center">
            <div>
              <Button
                type="button"
                color="secondary"
                onClick={onClickGuardar}
                className="mr-2"
              >
                Guardar
              </Button>
              <Button
                type="button"
                color="secondary"
                onClick={toggle}
                className="mr-2"
              >
                Salir
              </Button>
            </div>
          </div>
        </div>
      </MyModal>
    </>
  );
};

export default CalificarHabilitacion;
